import { useEffect, useState } from "react";
import rideService from "src/services/rideService";
import AddDistrictPopup from "./AddDistrictPopup";

export default function AvailableDistrict() {
    const [isAddDistrictPopUpOpen, setIsAddDistrictPopUpOpen] = useState(false);
    const [allDistrict, setAllDistrict] = useState([]);
    const [districtName, setDistrictName] = useState();
    const [id, setId] = useState();
    useEffect(() => {
        getAllAvailableDistrict();
    }, [])

    const getAllAvailableDistrict = async () => {
        await rideService.getAllDistrict().then((res) => {
            if (res.status == 200) {
                setAllDistrict(res.data.districts);
            }

        })
    }

    const deleteDistrict = async (districtId) => {
        await rideService.deleteDistrict(districtId).then((res) => {
            if (res.status == 200) {
                window.location.reload();
            }

        })
    }

    const handleUpdateOpenPopup=(id, name)=>{
        setIsAddDistrictPopUpOpen(!isAddDistrictPopUpOpen);
        setId(id);
        setDistrictName(name);
    }

    return (
        <>
            <button
                className="bg-indigo-500 text-white py-2 px-4 rounded-md hover:bg-indigo-600 focus:outline-none focus:bg-indigo-600"
            onClick={() => {
                setDistrictName("");
                setId();
                setIsAddDistrictPopUpOpen(!isAddDistrictPopUpOpen)}}
            >
                Add District
            </button>
            <div className="p-4">
                <h2 className="text-2xl font-bold mb-4">District</h2>
                <table className="table-auto w-full bg-white shadow-md rounded-lg overflow-hidden">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">District Name</th>

                            <th className="px-6 py-3 text-left text-sm font-semibold text-gray-700">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {allDistrict.map(district => (

                            <tr key={district.id} className="hover:bg-gray-50">

                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{district.district}</td>

                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    <button
                                        className="bg-indigo-500 text-white py-2 px-4 rounded-md hover:bg-indigo-600 focus:outline-none focus:bg-indigo-600"
                                    onClick={() => handleUpdateOpenPopup(district.id, district.district)}
                                    >
                                        Update
                                    </button>


                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                    <button
                                        className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-indigo-600 focus:outline-none focus:bg-indigo-600"
                                    onClick={() => deleteDistrict(district.id)}
                                    >
                                        Delete
                                    </button>


                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {
                isAddDistrictPopUpOpen && (
                    <AddDistrictPopup isOpen={isAddDistrictPopUpOpen} onClose={()=>setIsAddDistrictPopUpOpen(!isAddDistrictPopUpOpen)}  id={id} districtName={districtName} />
                )
            }
        </>
    )

}